<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>用户列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
          <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addUser" :loading="state" style="margin-right: 10px;">新增用户</el-button>
          <el-badge :value="totalStrip" class="item">
            <el-button type="danger" size="small" @click="deleteUser" :loading="state">删除选中用户</el-button>
          </el-badge>
        </el-card>
      </div>

      <el-form :inline="true" :model="queryInfo" class="demo-form-inline" ref="searchFormRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡类 " prop="cardPassword">
          <el-select v-model="queryInfo.cardName" placeholder="所有" clearable @change="changeInput()">
            <el-option v-for="item in allCardType" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态 " prop="softName" >
          <el-select v-model="queryInfo.state" placeholder="所有" clearable @change="changeInput()">
            <el-option label="正常" value="正常"></el-option>
            <el-option label="已过期" value="过期"></el-option>
            <el-option label="冻结" value="冻结"></el-option>
            <el-option label="封禁" value="封禁"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账号" prop="username">
          <el-input v-model="queryInfo.username"  clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'300px'}"></el-input>
        </el-form-item>

        <el-form-item label="绑定的卡密" prop="cardPassword">
          <el-input v-model="queryInfo.cardPassword"  clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'300px'}"></el-input>
        </el-form-item>

        <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
      </el-form>

      <el-table :data="tableUserList" border style="width: 100%" stripe v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="username" label="账号" width="200"></el-table-column>
        <el-table-column prop="password" label="密码" width="200"></el-table-column>
        <el-table-column prop="softName" label="所属软件" width="200"></el-table-column>
        <el-table-column prop="cardName" label="用户类型" width="200"></el-table-column>
        <el-table-column prop="online" label="在线" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.online === true" style="color: #237804" ><i class="iconfont icon-yuandianxiao" style="margin-right:0px;margin-left:0px;vertical-align:-2px"></i>在线</span>
            <span v-if="scope.row.online === false" style="color: #d80821"><i class="iconfont icon-yuandianxiao" style="margin-right:0px;margin-left:0px;vertical-align:-2px"></i>离线</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" width="70">
          <template slot-scope="scope">
            <!-- 1. 优先判断封禁 -->
            <span v-if="scope.row.freeze === true" style="color: #d80821">封禁</span>
            <!-- 2. 再判断冻结 -->
            <span v-else-if="scope.row.freezeTime === true" style="color: #d80821">冻结</span>
            <!-- 3. 根据 state 显示不同颜色 -->
            <span v-else-if="scope.row.state === '正常'" style="color: #237804">正常</span>
            <span v-else-if="scope.row.state === '未使用'" style="color: #606266">未使用</span>
            <span v-else-if="scope.row.state === '过期'" style="color: #ad6800">过期</span>
            <!-- 4. 兜底：如果都不是，直接显示后端返回的 state 值，绝不留白 -->
            <span v-else style="color: #909399">{{ scope.row.state}}</span>
          </template>
        </el-table-column>
         <el-table-column prop="upperLimit" label="多开" width="50"></el-table-column>
         <el-table-column prop="crowding" label="顶号" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.crowding === false" style="color: #d80821">否</span>
            <span v-if="scope.row.crowding === true" style="color: #237804">是</span>
          </template>
        </el-table-column>
        <el-table-column prop="unbundling" label="解绑" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.unbundling === false" style="color: #ad6800">未开启</span>
            <span v-if="scope.row.unbundling === true" style="color: #237804">是</span>
          </template>
        </el-table-column>

        <el-table-column label="当前解绑次数/允许解绑次数" width="140">
          <template #default="{row}">
            {{ row.currentUnbindNum }}/{{ row.unbindNumUpperLimit }}
          </template>
        </el-table-column>

        <el-table-column prop="createDate" label="注册时间" width="170"></el-table-column>
        <el-table-column prop="expireDate" label="到期时间" width="170"></el-table-column>
        <el-table-column prop="latelyDate" label="最近使用" width="170"></el-table-column>
        <el-table-column prop="freezeDate" label="冻结时间" width="170">
          <template slot-scope="scope">
            <span style="color: #d80821">{{scope.row.freezeDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" ></el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text"
              >编辑</el-button
            >
            <el-dropdown>
              <span class="el-dropdown-link" style="font-size:14px">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="cardLog(scope.row)">用卡记录</el-dropdown-item> -->
                <el-dropdown-item @click.native="userLog(scope.row)">日志</el-dropdown-item>
                <el-dropdown-item @click.native="kickLine(scope.row)">踢下线</el-dropdown-item>
                <el-dropdown-item @click.native="renew(scope.row)">快捷续费</el-dropdown-item>
                <el-dropdown-item v-if="!scope.row.freezeTime" @click.native="freezeUserListTime(scope.row)">冻结时间</el-dropdown-item>
                <el-dropdown-item v-else @click.native="unfreezeUserListTime(scope.row)">解冻时间</el-dropdown-item>
                <el-dropdown-item v-if="!scope.row.freeze" @click.native="freezeUserList(scope.row)" :style="{color:'red'}">封禁用户</el-dropdown-item>
                <el-dropdown-item v-else @click.native="unfreezeUserList(scope.row)" :style="{color:'red'}">解封用户</el-dropdown-item>
                <el-dropdown-item @click.native="delUserBtn(scope.row)" :style="{color:'red'}">删除用户</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑对话框editDiaLog -->
    <el-dialog title="编辑用户" :close-on-click-modal="false" :visible.sync="editDiaLogVisible" :width="editDialogWidth" class="edit">
      <el-form ref="editFromRef" :model="editFrom" label-width="80px" :rules="editFromRules" class="edit-form" size="small">
        <el-form-item label="用户名 " prop="username">
          <el-input v-model="editFrom.username" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="密码 " prop="password">
          <el-input v-model="editFrom.password"></el-input>
        </el-form-item>

        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="editFrom.softName" :disabled="true">
            <el-option :label="editFrom.softName" :value="editFrom.softName" ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注 " prop="remarks">
          <el-input type="textarea" v-model="editFrom.remarks" placeholder="长度不超过128个字符" :autosize="{ minRows: 1, maxRows: 2}"></el-input>
        </el-form-item>

        <el-form-item label="用户配置 " prop="configure">
          <el-input type="textarea" v-model="editFrom.configure" placeholder="长度不超过512个字符"></el-input>
        </el-form-item>
        <el-row>
          <el-form-item label="" prop="configure" label-width="22px">
            <div class="datetime" >
              <el-tooltip class="datetime-item" effect="dark" placement="top">
                <div slot="content">注意：未激活状态下修改到期时间还<br/>是会在用户激活卡密时覆盖掉。</div>
                <label for="customid" >到期时间<i class="iconfont icon-wenhaoxiao"></i></label>
              </el-tooltip>
              <el-col :span="8">
                <el-date-picker v-model="editFrom.expireDate" type="datetime" placeholder="选择日期时间" :style="inputWidth?{width:'180%'}:{width:'250px'}"></el-date-picker>
              </el-col>
            </div>
          </el-form-item>
        </el-row>
        <el-form-item label="" prop="configure" label-width="22px">
          <div class="custom">
            <label for="customid" class="islabel">是否冻结</label>
            <el-switch id="customid" style="display: block" v-model="editFrom.freeze" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="" prop="configure" label-width="22px">
          <div class="custom edit-custom">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">是否自定义 卡密前缀、顶号登录、多<br/>开上限 参数，它们默认是继承至所属<br/>软件</div>
              <label for="customids" >自定义<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="customids" style="display: block" v-model="editFrom.custom" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="" prop="singleDevice" label-width="22px" v-show="editFrom.custom">
          <div class="custom single">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">单设备多开:只绑定一个设备号，适用于pc软件<br/>多设备多开:绑定多个设备号，适用于手机软件</div>
              <label for="" >多开模式<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-radio class="lf" v-model="editFrom.singleDevice" label="true" border>单设备多开</el-radio>
            <el-radio class="lr" v-model="editFrom.singleDevice" label="false" border>多设备多开</el-radio>
          </div>
        </el-form-item>

        <el-form-item label="多开上限" prop="upperLimit" v-show="editFrom.custom">
          <el-input-number :precision="0" v-model="editFrom.upperLimit" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="允许解绑次数" prop="unbindNumUpperLimit" label-width="100px" v-show="editFrom.custom" class="unbindnum">
          <el-input-number :precision="0" v-model="editFrom.unbindNumUpperLimit" controls-position="right" :min="0" :max="9999999"></el-input-number>
        </el-form-item>
        <el-form-item label="当前解绑次数" prop="currentUnbindNum" label-width="100px" v-show="editFrom.custom" class="unbindnum">
          <el-input-number :precision="0" v-model="editFrom.currentUnbindNum" controls-position="right" :min="0" :max="9999999"></el-input-number>
        </el-form-item>

        <el-form-item label="" prop="configure" label-width="8px" v-show="editFrom.custom">
          <div class="custom crowding">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">在超过多开上限时，顶号登录：后登<br/>录的会把先登录的挤下线；不顶号登<br/>录：后登录的直接返回登录失败。</div>
              <label for="crowdingid" >顶号登录<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="crowdingid" style="display: block" v-model="editFrom.crowding" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="绑定设备号" prop="inputValue" label-width="100px" class="deviceid">
          <el-tag :key="tag" v-for="tag in editFrom.device_id" closable :disable-transitions="false" @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
            @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
          </el-input>
          
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 增 加</el-button>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="clearDevice" :loading="state">清空设备号</el-button>
        <el-button type="primary" @click="keepAlive" size="small" :loading="state">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 快捷续费卡密的Dialog -->
    <el-dialog title="快捷续费" :close-on-click-modal="false" :visible.sync="reNowDialog" :width="diaLogWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>快捷续费<br></span>
      </div>
      <span style="margin-left:30px">确定要将{{reNowData.username}}用户续费 {{reNowData.cardName}}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reNowDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="reNowDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除用户的Dialog -->
    <el-dialog title="删除用户" :close-on-click-modal="false" :visible.sync="delUserDialog" :width="diaLogWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>删除用户<br></span>
      </div>
      <span style="margin-left:30px">确定要将{{delUserData.username}}用户 删除?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delUserDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="delUserDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增用户Dialog -->
    <el-dialog title="新增用户" :close-on-click-modal="false" :visible.sync="addUserDialog" :width="addUserDialogWidth">
      <el-form ref="addUserFromRef" :model="addUserFrom" label-width="80px" :rules="addUserFromRules" class="edit-form" size="small" style="margin: 0 20px 0 20px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addUserFrom.username"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="addUserFrom.password"></el-input>
        </el-form-item>

        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="addUserFrom.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="使用卡类" prop="cardType">
          <el-select v-model="addUserFrom.cardType" placeholder="请选择卡类" clearable @change="changeInput()">
            <el-option v-for="item in allCardType" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="备注 " prop="remarks">
          <el-input type="textarea" v-model="addUserFrom.remarks" placeholder="长度不超过128个字符" :autosize="{ minRows: 1, maxRows: 2}"></el-input>
        </el-form-item>

        <el-form-item label="用户配置" prop="configure">
          <el-input type="textarea" v-model="addUserFrom.configure" placeholder="长度不超过512个字符"></el-input>
        </el-form-item>

        <el-form-item label="" prop="configure" label-width="22px">
          <div class="custom edit-custom">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">是否自定义 卡密前缀、顶号登录、多<br/>开上限 参数，它们默认是继承至所属<br/>软件</div>
              <label for="customids" >自定义<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="customids" style="display: block" v-model="addUserFrom.custom" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="" prop="singleDevice" label-width="22px" v-show="addUserFrom.custom">
          <div class="custom single">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">单设备多开:只绑定一个设备号，适用于pc软件<br/>多设备多开:绑定多个设备号，适用于手机软件</div>
              <label for="" >多开模式<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-radio class="lf" v-model="addUserFrom.singleDevice" label="true" border>单设备多开</el-radio>
            <el-radio class="lr" v-model="addUserFrom.singleDevice" label="false" border>多设备多开</el-radio>
          </div>
        </el-form-item>

        <el-form-item label="多开上限" prop="upperLimit" v-show="addUserFrom.custom">
          <el-input-number :precision="0" v-model="addUserFrom.upperLimit" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-form-item label="允许解绑次数" prop="unbindNumUpperLimit" v-show="addUserFrom.custom" label-width="100px" class="unbindnum">
          <el-input-number :precision="0" v-model="addUserFrom.unbindNumUpperLimit" controls-position="right" :min="0" :max="9999999"></el-input-number>
        </el-form-item>
        <el-form-item label="" prop="configure" label-width="8px" v-show="addUserFrom.custom">
          <div class="custom crowding">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">在超过多开上限时，顶号登录：后登<br/>录的会把先登录的挤下线；不顶号登<br/>录：后登录的直接返回登录失败。</div>
              <label for="crowdingid" >顶号登录<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="crowdingid" style="display: block" v-model="addUserFrom.crowding" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUserDialogBtn" size="small" :loading="state">创 建</el-button>
      </span>
    </el-dialog>
    
    <!-- 用户在线日志Dialog -->
    <el-dialog :title="userTitle" :close-on-click-modal="false" :visible.sync="userLogdialog" :width="userDialogWidth">
      <div class="card-log">
        <el-card>
          <div class="card-header-flex">
            <div class="left-actions">
              <el-button size="small" type="primary" icon="el-icon-refresh" circle @click="userlogRefresh" :loading="state" class="userlogrefresh"></el-button>
              <el-badge :value="totalOnline" class="item">
                <el-popover placement="top-start"  :width="popoverWidth" trigger="hover">
                  <div style="margin-bottom:10px;margin-left:10px">
                    序号 : <el-tag size="small">设备号</el-tag> : <el-tag class="token" size="small" >token</el-tag>  : <el-tag class="token" size="small" type="success" effect="dark">心跳time</el-tag>
                  </div>
                  <div class="popover-scroll-container">
                    <div v-for="(item, index) in online" :key="item.token" style="margin-bottom:10px;margin-left:10px">
                      {{index+1}} : <el-tag size="small">{{item.split(":")[0]}}</el-tag> : <el-tag class="token" size="small" >{{item.split(":")[1]}}</el-tag> : <el-tag class="time" size="small" type="success" effect="dark">{{timestampToTime(parseInt(item.split(":")[2])).substring(timestampToTime(parseInt(item.split(":")[2])).length - 8)}}</el-tag> 
                    </div>
                  </div>
                  <el-button slot="reference" size="small" :loading="state">当前在线</el-button>
                </el-popover>
              </el-badge>
            </div>
            <el-select v-model="selectedLogDate" placeholder="请选择日志日期" size="small" style="width: 160px; margin-right: 10px;" @change="handleDateChange">
              <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-card>
      </div>
      <el-table :data="userLogData" border style="width: 100%" stripe>
        <el-table-column prop="action" label="动作" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.action === '登录'" style="color: #237804">登录</span>
            <span v-if="scope.row.action === '退出登录'" style="color: #0050b3">退出登录</span>
            <span v-if="scope.row.action === '解绑'" style="color: #ad6800">解绑</span>
            <span v-if="scope.row.action === '冻结'" style="color: #db0d0d">冻结</span>
            <span v-if="scope.row.action === '充值'" style="color: #db0d0d">充值</span>
            <span v-if="scope.row.action === '时间转移'" style="color: #db0d0d">时间转移</span>
            <span v-if="scope.row.action === '邀请充值'" style="color: #db0d0d">邀请充值</span>
            <span v-if="scope.row.action === '赠送'" style="color: #d48806">赠送</span>
          </template>
        </el-table-column>
        <el-table-column prop="sign" label="记录" >
          
          <template slot-scope="scope">
            <el-popover placement="top-start" trigger="hover" popper-class="my-popover">
              <code>
                <div v-if="Array.isArray(scope.row.sign)">
                  <span class="code-span" v-for="item in scope.row.sign" :key="item" style="margin-left:20px;margin-right:20px">{{item}}</span>
                </div>
                <div v-if="Object.prototype.toString.call(scope.row.sign) === '[object Object]'">
                  <span class="code-span">{</span>
                  <span class="code-span" v-for="(item,index) in scope.row.sign" :key="index" style="margin-left:20px;margin-right:20px">{{index}}: {{item}}</span>
                  <span class="code-span">}</span>
                </div>
                <div v-if="typeof(scope.row.sign)=='string'">
                  <span class="code-span" style="margin-left:20px;margin-right:20px">{{scope.row.sign}}</span>
                </div>
              </code>
              <div class="text-record" slot="reference" v-if="scope.row.sign">{{ scope.row.sign | capitalize }}</div>
            </el-popover>
          </template>
        
        </el-table-column>
        <el-table-column prop="ip" label="ip"  width="200">
          <template slot-scope="scope">
            <el-popover placement="top-start" width="200" trigger="hover"  popper-class="my-popover"  @show="showpopo(scope.row.ip)">
              <!-- <span class="code-span" v-for="(item,index) in ip" :key="index" style="margin-left:20px">{{index}}: {{item}},</span> -->
              <code>{{ip}}</code>
              <span style="color: #1890ff" slot="reference">{{ scope.row.ip }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="时间" width="170"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="onlineHandleSizeChange"
        @current-change="onlineHandleCurrentChange"
        :current-page="onlineQueryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="onlineQueryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="onlineTotal"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="userLogdialog = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 删除未过期卡密 -->
    <el-dialog title="确定要删除选中用户？" :visible.sync="deleteSelectionUserDialog" :width="deleteSelectionUserDialogWidth">
      <span style="color:red">确定要删除*选中*用户？删除后无法找回</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="deleteSelectionUserDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="batchDeleteUser">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    let checkChina = (rule,value,cb) => {
      const checkChina = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if(checkChina.test(value)){
        cb(new Error('用户名不能包含中文'))
      }else{
        return cb()
      }
    }
    return{
      state:false,
      loading:true,
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
      },
      
      allSoftName:[],
      allCardType:[],
      tableUserList:[],
      total:0,

      editDiaLogVisible:false,
      editFrom:[],
      editDialogWidth:'500px',
      diaLogWidth:"500px",
      editFromRules:{
        dateTime:'',
        password: [
          { required: true, message: "请输入密码", trigger: ["blur", "change"] },
          { min: 5, max: 16, message: "密码长度在 5 到 16 个字符", trigger: ["blur", "change"]},
        ],
        remarks: [
          { min: 0,max: 128,message: "备注最大长度是128个字符",trigger: ["blur", "change"]},
        ],
        configure: [
          { min: 0,max: 512,message: "配置最大长度是512个字符",trigger: ["blur", "change"]},
        ]
      },
      inputVisible: false,
      inputWidth: false,
      reNowDialog:false,
      reNowData:"",
      delUserData: "",
      delUserDialog: false,
      inputValue:"",
      
      addUserFrom:{
        softName: "",
        cardType: "",
        remarks: "",
        configure: "",
        upperLimit:"",
        crowding: false,
        singleDevice: "false",
        unbindNumUpperLimit:9999999
      },
      addUserFromRules:{
        username: [
          { required: true, message: "请输入用户名", trigger: ["blur", "change"] },
          { min: 5, max: 40, message: "长度在 5 到 40 个字符", trigger: ["blur", "change"]},
          { validator: checkChina, trigger:'blur'}
        ],
        password: [
          { required: true, message: "请输入密码", trigger: ["blur", "change"] },
          { min: 5, max: 16, message: "长度在 5 到 16 个字符", trigger: ["blur", "change"]},
        ],
        softName:[
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        cardType:[
          { required: true, message: "请选择卡类!", trigger: ["blur", "change"] },
        ],
        remarks: [
          { min: 0,max: 128,message: "备注最大长度是128个字符",trigger: ["blur", "change"]},
        ],
        configure: [
          { min: 0,max: 512,message: "配置最大长度是512个字符",trigger: ["blur", "change"]},
        ]
      },
      addUserDialogWidth: '500px',
      userTitle:"",
      userLogdialog: false,
      userDialogWidth:'1000px',
      addUserDialog: false,
      totalOnline: '',
      online: [],
      popoverWidth:'560',
      ip:"",
      onlineQueryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
      },
      onlineTotal: 0,
      selectedLogDate:"",
      dateOptions:[],
      userLogData:[],
      totalStrip:"",
      btnLoading: false,
      multipleSelectionUser: [],
      deleteSelectionUserDialogWidth: '500px',
      deleteSelectionUserDialog: false
    }
  },
  created(){
    this.$nextTick(()=>{
      if (document.body.clientWidth < 768){
        this.diaLogWidth = '100%'
        this.inputWidth = true
        this.editDialogWidth = '100%'
        this.addUserDialogWidth = '100%'
        this.userDialogWidth = '100%'
        this.deleteSelectionUserDialogWidth = '100%'
      }
    })
    this.getUserList()
    this.getCardTypeSoftName()
    this.initDateOptions();
  },
  methods:{
    async getUserList(){
      //console.log(this.queryInfo);
      this.state = true
      const result = await this.$http.get("getUserList",{
        params: this.queryInfo
      });
      this.state = false
      console.log(result);
      if(!result.data.data.total){
        this.total = 0
        this.tableUserList = []
        this.loading = false
        return
      }
      //this.tableUserList = result.data.data.data
      this.tableUserList = result.data.data.data.map(element =>{
        if(element.singleDevice){
          element.singleDevice = "true";
        }else{
          element.singleDevice = "false";
        }
        if(element.createDate){
          element.createDate = this.timestampToTime(parseInt(element.createDate))
        }
        if(element.expireDate){
          element.expireDate = this.timestampToTime(parseInt(element.expireDate))
        }
        if(element.latelyDate){
          element.latelyDate = this.timestampToTime(parseInt(element.latelyDate))
        }
        if(element.freezeDate){
          element.freezeDate = this.timestampToTime(parseInt(element.freezeDate))
        }
        return element
      })
      this.total = result.data.data.total
      this.loading = false
    },
    async getCardTypeSoftName(){
      this.state = true
      const result = await this.$http.post("cardGetSoft", {});
      this.state = false
      //console.log(result);
      this.allSoftName = result.data.data.result.map(element => {
        return element.softName
      })
      this.addUserFrom.softName = this.allSoftName
      this.allCardType = result.data.data.resolve.map(element => {
        return element.cardName
      })
      this.addUserFrom.cardType = this.allCardType
    },

    refresh(){
      this.getUserList()
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getUserList()
    },
    reSet(){
      console.log('重置');
      this.queryInfo.softName = ""
      this.queryInfo.cardName = ""
      this.queryInfo.state = ""
      this.queryInfo.username = ""
      this.$refs.searchFormRef.resetFields()
      this.getUserList()
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getUserList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getUserList()
    },
    //编辑点击事件
    handleClick(index){
      this.editDiaLogVisible = true
      this.editFrom = index
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    clearDevice(){
      this.editFrom.device_id = []
    },
    keepAlive(){
      this.$refs.editFromRef.validate(async (value) => {
        if(!value) return
        
        if (this.editFrom.device_id && this.editFrom.device_id.length > 0) {
          const overLengthId = this.editFrom.device_id.find(id => id.length > 50);
          if (overLengthId) {
            this.$notify.error({
              title: '更改失败',
              message: `设备号 [${overLengthId.substring(0, 10)}...] 长度超过 50 位限制`
            });
            return;
          }
        }

        this.state = true
        const result = await this.$http.post('updateUserList',this.editFrom)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.editDiaLogVisible = false
        this.getUserList()
      })
    },
    //冻结用户
    async freezeUserList(value){
      console.log(value);
      this.state = true
      const result = await this.$http.post("freezeUserList", value);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getUserList()
    },
    //解冻用户
    async unfreezeUserList(value){
      this.state = true
      const result = await this.$http.post("unfreezeUserList", value);
      console.log(result);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getUserList()
    },
    //冻结时间
    async freezeUserListTime(value){
      console.log(value);
      this.state = true
      const result = await this.$http.post("freezeUserListTime", value);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getUserList()
    },
    //解冻时间
    async unfreezeUserListTime(value){
      this.state = true
      const result = await this.$http.post("unfreezeUserListTime", value);
      console.log(result);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getUserList()
    },
    async kickLine(val){
      this.state = true
      let result = await this.$http.post('kickuserdownline',val)
      this.state = false
      if(result.data.meta.status === 200){
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.getUserList()  
      }
    },
    //用卡记录
    cardLog(index){
      this.$bus.$emit('itemclick',index)
      window.sessionStorage.setItem('path', "userlog")
      this.$store.state.path = window.sessionStorage.getItem('path')
    },
    initDateOptions() {
      const options = [];
      for (let i = 0; i < 10; i++) {
        const date = new Date();
        date.setDate(date.getDate() - i); // 依次往前推

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        // 存储格式：20240506 (后端查表用)
        const value = `${year}${month}${day}`;
        // 显示格式：2024-05-06 (用户看)
        const label = i === 0 ? `今天 (${year}-${month}-${day})` : `${year}-${month}-${day}`;
        
        options.push({ value, label });
      }
      this.dateOptions = options;
      this.selectedLogDate = options[0].value; // 默认选中第一项（今天）
    },
    // 切换日期时的逻辑
    handleDateChange(val) {
      console.log('切换到日期表：', val);
      // 这里触发你的查询方法
      this.userlogRefresh(); 
    },

    // 修改你的刷新方法，带上日期参数
    userlogRefresh() {
      this.state = true;
      // 请求后端接口时，带上 this.selectedLogDate
      const params = {
        date: this.selectedLogDate, // 传给后端的后缀
        // ... 其他参数
      };
      
      this.userLog(this.onlineIndex)
    },
    //日志
    async userLog(index){
      this.online = ""
      this.totalOnline = ""
      console.log('index',index);
      if(index){
        this.onlineIndex = index
      }
      this.userTitle = '用户在线日志: '+this.onlineIndex.username
      this.state = true
      const result = await this.$http.get('useronlinelog',{
        params: {
          email: this.$store.state.account,
          index: this.onlineIndex,
          queryInfo: this.onlineQueryInfo,
          logDate: this.selectedLogDate
        },
      })
      // console.log('用户日志result-->',result);
      this.state = false
      if(result.data.data.resolve){
        if(result.data.data.resolve.length > 0){
          this.userLogData = result.data.data.resolve.map(element => {
            if(element.createDate){
              element.createDate = this.timestampToTime(parseInt(element.createDate))
            }
            if(element.sign.indexOf('{') > -1){
              element.sign = JSON.parse(element.sign)
            }else if(element.sign.indexOf('[') > -1){
              element.sign = JSON.parse(element.sign)
            }
            return element
          })
        }else{
          this.userLogData = []
        }
        if(result.data.data.resData){
          // this.online = JSON.parse(result.data.data.resData)
          this.online = result.data.data.resData
          console.log('this.online',this.online);
          this.totalOnline = this.online.length
        }else{
          this.totalOnline = ""
        }
        this.onlineTotal = result.data.data.total
      }else{
        this.userLogData = []
        this.onlineTotal = 0
      }

      // if(result.data.data){
      //   // this.online = JSON.parse(result.data.data.resData)
      //   this.online = result.data.data
      //   // console.log('this.online',this.online);
      //   this.totalOnline = this.online.length
      // }else{
      //   this.totalOnline = ""
      // }
      this.userLogdialog = true
    },

    onlineHandleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.onlineQueryInfo.pagesize = val
      this.userLog()
    },
    // 监听 页码值 改变的事件
    onlineHandleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.onlineQueryInfo.pagenum = val
      this.userLog()
    },
    close() {
      this.batchOperationForm.info = ""
      this.$refs.batchOperationFormRef.resetFields()
    },
    async showpopo(val){
      console.log('显示时候触发',val);
      let result = window.localStorage.getItem(val)
      if(!result){
        this.state = true
        result = await this.$http.post('getIp',{ip:val})
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          return this.$notify.error({title: '获取失败',message:result.data.meta.msg});
        }
        result = result.data.data
        window.localStorage.setItem(val, JSON.stringify(result))
      }
      this.ip = result
    },
    //快捷续费
    renew(index){
      console.log('index',index);
      this.reNowData = index
      this.reNowDialog = true
    },
    async reNowDialogBtn(){
      this.loading = true
      this.state = true
      const result = await this.$http.post("reNow", this.reNowData);
      this.state = false
      this.loading = false
      console.log(result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.reNowDialog = false
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getUserList()
    },
    delUserBtn(index){
      this.delUserData = index
      this.delUserDialog = true
    },
    async delUserDialogBtn(){
      this.loading = true
      this.state = true
      const result = await this.$http.post("deluser", this.delUserData);
      this.state = false
      this.loading = false
      console.log(result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.delUserDialog = false
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getUserList()
    },
    addUser(){
      this.addUserDialog = true;
    },
    addUserDialogBtn(){
      this.$refs.addUserFromRef.validate(async (value) => {
        console.log("value: " + value);
        if (value) {
          this.state = true
          const result = await this.$http.post("addUser", this.addUserFrom);
          console.log("增加用户",result);
          this.state = false
          if(result.data.meta.status !== 200){
            this.$notify.error({title: '错误',message:result.data.meta.msg});
            return
          }
          this.addUserDialog = false;
          this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
          this.$refs.addUserFromRef.resetFields()
          this.getUserList()
        }else {
          return this.$message.error("请填写必填项");
        }
      })
    },
    handleClose(tag) {
      this.editFrom.device_id.splice(this.editFrom.device_id.indexOf(tag), 1);
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        // if (inputValue.length > 50) {
        //   this.$message.error('单个设备号长度不能超过 50 个字符！');
        //   return; 
        // }
        // if (this.editFrom.device_id.includes(inputValue)) {
        //   this.$message.warning('该设备号已存在');
        //   return;
        // }
        this.editFrom.device_id.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1);
      var day = date.getDate();
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month < 10) { month = '0' + month }
      if (day < 10) { day = '0' + day }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second;
    },
    changeInput(e){
      this.$forceUpdate()
    },
    async showpopo(val){
      //console.log('显示时候触发',val);
      let result = window.localStorage.getItem(val)
      if(!result){
        this.state = true
        result = await this.$http.post('getIp',{ip:val})
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          return this.$notify.error({title: '获取失败',message:result.data.meta.msg});
        }
        result = result.data.data
        window.localStorage.setItem(val, JSON.stringify(result))
      }
      this.ip = result
    },
    handleSelectionChange(val) {
      this.multipleSelectionUser = val
      this.totalStrip = this.multipleSelectionUser.length
      console.log('multipleSelectionUser',this.multipleSelectionUser);
      if(this.multipleSelectionUser.length === 0){
        this.totalStrip = ""
      }
    },
    deleteUser() {
      // 安全守卫：如果没有勾选任何用户，不触发弹窗并给出提示
      // console.log("00multipleSelectionUser=",this.multipleSelectionUser);
      if (this.multipleSelectionUser.length === 0) {
        this.$message.warning('请先勾选需要删除的用户！');
        return;
      }
      this.deleteSelectionUserDialog = true
    },

    // 2. 核心异步删除请求方法
    async batchDeleteUser() {
      // 开启按钮的 loading 状态
      this.state = true;
      try {
        const ids = this.multipleSelectionUser.map(item => item._id);
        // 发送网络请求，将 ids 传给后端
        const result = await this.$http.post("batchdeleteuser", { ids: ids });
        if (result.data.meta.status !== 200) {
          this.$notify.error({ title: '错误', message: result.data.meta.msg });
          return;
        }
        this.$notify({ title: '成功', message: result.data.meta.msg, type: 'success' });
        if (this.$refs.tableUserList) {
          this.$refs.tableUserList.clearSelection();
        }
        this.deleteSelectionUserDialog = false
        this.getUserList();
      } catch (error) {
        console.error("删除接口请求失败：", error);
        this.$message.error('请求服务器失败，请稍后再试');
      } finally {
        // 无论成功或失败，最后都关闭按钮的 loading 状态
        this.state = false;
      }
    }
  },
  filters:{
    capitalize(value){
      if(Array.isArray(value)){
        value = value.toString()
        value = value.replace('[','')
        value = value.replace(']','')
      }
      return value
    }
  }
}
</script>

<style lang="less" scoped>
// .content {
//   margin: 20px;
//   .el-pagination {
//     margin-top: 20px;
//     display: flex;
//     justify-content: flex-end;
//     flex-wrap: wrap;
//   }
//   .el-dropdown{
//     margin-left: 10px;
//     color: #409EFF;
//   }
//   .el-table{
//     .el-button{
//       margin-left: 10px
//     }
//   }
// }
// .custom{
//   display: flex;
//   justify-content: flex-start;
//   .el-switch{
//     margin-left: 10px;
//   }
// }

.content {
  margin: 5px;
  .el-table{
    .el-button{
      margin: 5px 10px;
    }
    
  }
  
  .operation{
    margin-left: 10px;
    margin-right: 0px;
  }
  .navbtn{
    margin-bottom: 20px;
  }
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .el-dropdown{
    margin-left: 10px;
    color: #409EFF;
  }
  .el-table{
    .el-button{
      margin-left: 10px;
    }
    td{
      padding: 0 !important;
      height: 30px;
      line-height: 30px;
    }
  }
  .lately{
    margin-top: -3px;
    vertical-align: 1px;
  }
  .lately-div{
    margin-top: -7px;
  }
}
.el-badge{
  margin-right: 30px;
}
.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-top: 6px;
  }
}

.el-tooltip{
  float: left;
  margin-left: 25px;
}
.itemlist{
  margin-left: 0px;
}
.batch{
  display: flex;
  justify-content:space-around
}

.datetime{
  margin-left: -58px;
}

.islabel{
  padding-right: 13px;
  margin-left: -11px;
}
.edit-custom{
  margin-left: -44px;
}

.edit-form{
  margin-left: 20px;
  
}

.crowding{
  margin-left: -45px;
}
.deviceid{
  margin-left: -20px;
}
.newcreatecardpassword{
  .el-form-item{
    padding: 0 35px 0 0;
  }
}
.edit{
  .el-form-item{
    padding: 0 35px 0 0;
  }
}

.frezee{
  margin-left: 0px !important;
}

.userlogrefresh{
  margin-right: 10px;
}

.el-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.single{
  margin-left: -58px;
}

.unbindnum{
  margin-left: -20px;
}

.card-log{
  // margin: 0 10px;
  margin-bottom: 20px;
  .el-card{
    border-radius: 7px;
  }
  .el-card__body{
    padding: 10px !important;
  }
}
.popover-scroll-container {
    /* 设置最大高度，超过此高度将出现滚动条 */
    max-height: 70vh; 
    /* 纵向滚动 */
    overflow-y: auto;
    /* 优化滚动条在移动端或现代浏览器下的体验 */
    overflow-x: hidden;
    padding-right: 5px;
    -webkit-overflow-scrolling: touch;
}

/* 可选：美化滚动条（针对 Webkit 浏览器） */
.popover-scroll-container::-webkit-scrollbar {
    width: 6px;
}
.popover-scroll-container::-webkit-scrollbar-thumb {
    background: #e5e5e5;
    border-radius: 10px;
}
.popover-scroll-container::-webkit-scrollbar-track {
    background: transparent;
}

.card-header-flex {
  display: flex;
  align-items: center;
  /* 关键：让子元素分别靠左和靠右 */
  justify-content: space-between; 
  white-space: nowrap;
  /* 移动端如果太窄依然允许滚动 */
  // overflow-x: auto;
}

/* 左侧按钮容器，内部也要 Flex 布局来保持间距 */
.left-actions {
  display: flex;
  align-items: center;
  gap: 10px; /* 按钮之间的间距 */
}

.date-select {
  width: 150px !important;
  /* 电脑端时，如果不想它贴得太死，可以加个微调 */
  margin-left: 20px; 
}

/* 隐藏滚动条 */
.card-header-flex::-webkit-scrollbar {
  display: none;
}

.el-table{
  .text-record{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
}
@media screen and (max-width:479px) {
  .el-form-item{
    .lf{
      margin: 0;
    }
    .lr{
      margin-left: 6px !important;
    }
  }
}
</style>